import React, { type ComponentType } from 'react';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { lazy } from '@atlassian/react-loosely-lazy';
import type { JSErrorPageProps } from './JSErrorPage.tsx';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const LazyJSErrorPage = lazy<ComponentType<JSErrorPageProps>>(() =>
	import(/* webpackChunkName: "async-js-error-page" */ './JSErrorPage.tsx').then(
		(module) => module.JSErrorPage,
	),
);

export const JSErrorPageAsync = (props: JSErrorPageProps): React.JSX.Element => (
	<Placeholder name="async-js-error-page" fallback={null}>
		<LazyJSErrorPage {...props} />
	</Placeholder>
);
